import { Component } from '@theme/component';
import { morphSection } from '@theme/section-renderer';
import { requestYieldCallback } from '@theme/utilities';

export default class VariantPicker extends Component {
  #abortController;

  connectedCallback() {
    super.connectedCallback();

    // Delegate on the container so listeners survive re-renders.
    // (morph swaps input nodes, which kills per-input listeners.)
    this.addEventListener('change', (event) => {
      const target = event.target;
      if (
        target instanceof HTMLElement &&
        target.matches('select, input[type="radio"]')
      ) {
        this.variantChanged(target);
      }
    });
  }

  variantChanged(target) {
    // Gather EVERY currently selected option value id = the full combination.
    const selectedOptionValueIds = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select')
    )
      .map((el) =>
        el instanceof HTMLSelectElement
          ? el.selectedOptions[0]?.dataset.optionValueId
          : el.dataset.optionValueId
      )
      .filter(Boolean);

    const sectionId = this.dataset.sectionId;

    // Combined listings: if this option value points to a sibling product, use it.
    const productUrl =
      target.dataset.connectedProductUrl || this.dataset.productUrl;

    // Abort any in-flight request.
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    // Shopify's required format: comma-joined option_values + section_id.
    const requestUrl =
      `${productUrl.split('?')[0]}?section_id=${sectionId}` +
      `&option_values=${selectedOptionValueIds.join(',')}`;

    fetch(requestUrl, { signal: this.#abortController.signal })
      .then((res) => res.text())
      .then(async (responseText) => {
        // Re-render the whole product section at once: picker, price,
        // gallery, and the buy-buttons hidden variant id all stay in sync.
        await morphSection(sectionId, responseText);
        this.updateUrl();
      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.error(err);
      });
  }

  updateUrl() {
    // Read the REAL combination variant id from the freshly rendered
    // buy-buttons input, not from a single radio's representative variant.
    const variantInput = document.querySelector(
      `#shopify-section-${this.dataset.sectionId} form[action*="/cart/add"] input[name="id"]`
    );
    const variantId = variantInput?.value;
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    requestYieldCallback(() => history.replaceState({}, '', url.toString()));
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}